import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    name: "confirm-dialog",
    props: {
        confirmTitle: {
            type: definePropType(String),
            default: ""
        },
        confirmContent: {
            type: definePropType(String),
            default: ""
        }
    }
});
